import { instance } from './_config.js'
import { jwtDecode } from "jwt-decode";


const getUsers = async () => {
    try {
        const rs = await instance.get(`users`)
        if (rs.data?.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}


const updateUser = async (obj) => {
    try {
        const rs = await instance.put(`users`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


const creatUser = async (obj) => {
    try {
        const rs = await instance.post(`users`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}

const deleteUser = async (id) => {
    try {
        const rs = await instance.delete(`users`, { data:{'_id': id},  })
        if (rs.data) {
            return rs.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}   


const password = async (obj) => {
    try {
        const rs = await instance.post(`/auth/password`, obj, )
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}

const login = async (user, password) => {
    try {
        const rs = await instance.post('auth',{ login: user, password: password })
        if (rs.data) {
            const token = rs.data.data?.token
            if (token) {
                const decoded = jwtDecode(token);

                localStorage.setItem('firstName', decoded.firstName)
                localStorage.setItem('lastName', decoded.lastName)
                localStorage.setItem('token', token)
                localStorage.setItem('role', decoded.role)
                localStorage.setItem('_id', decoded._id)
                localStorage.setItem('user', decoded.firstName + ' ' + decoded.lastName)
                return true
            }
        }
    }
    catch (err) {
        if (window.localStorage.getItem('token')) {
            localStorage.clear();
        }
        console.log(err)
        return false
    }
}



export { getUsers, updateUser, creatUser, deleteUser, password, login }